import { render, staticRenderFns } from "./SBSWidget.vue?vue&type=template&id=d388d96e&scoped=true"
import script from "./SBSWidget.vue?vue&type=script&lang=js"
export * from "./SBSWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d388d96e",
  null
  
)

export default component.exports